import React, { useState, useEffect } from 'react';
import MultiSelect from './MultiSelect';
import skillApi from '../api/skillApi';
import { useToast } from '../contexts/ToastContext';

const SkillsMultiSelect = ({ value, onChange, error, label = "Skills/Technologies", required = false }) => {
  const { addToast } = useToast();
  const [availableSkills, setAvailableSkills] = useState([]);
  const [loadingSkills, setLoadingSkills] = useState(true);

  useEffect(() => {
    const fetchSkills = async () => {
      setLoadingSkills(true);
      try {
        const response = await skillApi.getSkills({ paginate: false, includeTrashed: false });
        if (response.success && response.data) {
          setAvailableSkills(response.data.map(skill => ({ value: skill.id, label: skill.name })));
        } else {
          addToast('Failed to load available skills.', 'error');
        }
      } catch (err) {
        console.error('Error fetching skills for MultiSelect:', err);
        addToast('Failed to load available skills. Please try again.', 'error');
      } finally {
        setLoadingSkills(false);
      }
    };
    fetchSkills();
  }, [addToast]);

  const selectedOptions = value.map(skillId => {
    const skill = availableSkills.find(s => s.value === skillId);
    return skill || { value: skillId, label: `Unknown Skill (${skillId})` };
  });

  return (
    <div className="mb-4">
      <label className="block text-text-gray text-sm font-bold mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <MultiSelect
        options={availableSkills}
        value={selectedOptions}
        onChange={onChange}
        placeholder={loadingSkills ? "Loading skills..." : "Select skills..."}
        isDisabled={loadingSkills}
        error={error}
      />
      {error && <p className="text-red-500 text-xs italic mt-1">{error}</p>}
    </div>
  );
};

export default SkillsMultiSelect;